import styled from 'styled-components';

interface Props {
	size?: number
}

const ColSpacer = styled.div<Props>`
    padding-left: ${props => props.size}px;
    padding-right: ${props => props.size}px;
`;

ColSpacer.defaultProps = {
	size: 20
}  

export default ColSpacer